import { render, staticRenderFns } from "./GoodsAdministrativeApproval.vue?vue&type=template&id=3fce3977&scoped=true"
import script from "./GoodsAdministrativeApproval.vue?vue&type=script&lang=js"
export * from "./GoodsAdministrativeApproval.vue?vue&type=script&lang=js"
import style0 from "./GoodsAdministrativeApproval.vue?vue&type=style&index=0&id=3fce3977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce3977",
  null
  
)

export default component.exports